
import {defineComponent} from 'vue'
import ContentPageElementVisibilityRule
  from "@/components/layouts/content-pages/wysiwyg/ContentPageElementVisibilityRule.vue";

export default defineComponent({
  name: "ContentPageRowVisibilityRule",
  emits: ["saved"],
  components: {ContentPageElementVisibilityRule},
  props: {
    pageId: {
      type: String,
      required: true
    },
    rowId: {
      type: String,
      required: true
    }
  },
  methods: {
    /**
     * Called by the page when this offcanvas is opened; handed straight to the component that owns
     * the rule.
     */
    async reload(): Promise<void> {
      await (this.$refs.elementVisibilityRule as { reload(): Promise<void> } | undefined)?.reload();
    }
  }
})
